import { DraftsRounded } from '@material-ui/icons';
import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function pleitoPostoAnexo(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@pleitopostoanexo/FIND_PLEITOPOSTOANEXO':
      case '@pleitopostoanexo/UPDATE_PLEITOPOSTOANEXO':
      case '@pleitopostoanexo/DELETE_PLEITOPOSTOANEXO':
      case '@pleitopostoanexo/STORE_PLEITOPOSTOANEXO':
      case '@pleitopostoanexo/PLEITOPOSTOANEXO_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@pleitopostoanexo/SUCCESS_REMOVE':
      case '@pleitopostoanexo/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@pleitopostoanexo/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.pleitopostoanexos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@pleitopostoanexo/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.pleitopostoanexos;
        break;
      }

      case '@pleitopostoanexo/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params
        break;
      }
      case '@pleitopostoanexo/RESET_VALUES': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
